import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonApiService } from 'src/helper/common-api.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css'],
})
export class EventComponent implements OnInit {
  getEventArray: any = [];
  p = 1;

  constructor(private commonApiService: CommonApiService) {}

  ngOnInit(): void {
    this.getEventDetail();
  }

  paginate(event) {
    this.p = event;
  }

  getEventDetail() {
    this.commonApiService
      .getPromiseResponse({
        apiName: '/event',
        methodType: 'get',
        parameterObject: null,
      })
      .then((result: any) => {
        this.getEventArray = result;
      })
      .catch((err: any) => {});
  }

  sortFunction(a, b) {
    var dateA = new Date(a.EventTime).getTime();
    var dateB = new Date(b.EventTime).getTime();
    return dateA > dateB ? 1 : -1;
  }
  convertToLocalDate(utcDate) {
    var date = new Date(utcDate + '.00Z');
    return date.toString();
  }
}
